import { createUppyPlugin } from '@ugi/core';

export const UppyPlugin = createUppyPlugin({
  endpoint: import.meta.env.VITE_UGI_API_URL,
  cookiesRule: 'include',
});
